import { z } from "zod";

export const bulkDownloadInvoicePdfBodySchema = z.object({
    invoiceIds: z
        .array(z.string().uuid())
        .min(1)
        .max(200)
        .refine(
            (invoiceIds) => new Set(invoiceIds).size === invoiceIds.length,
            {
                message: "invoiceIds must not contain duplicates",
            },
        ),
});

export type BulkDownloadInvoicePdfBody = z.infer<
    typeof bulkDownloadInvoicePdfBodySchema
>;
